(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .service('patrimoinePropertyService', patrimoinePropertyService);


    /**
    * @ngdoc service
    * @name swif.patrimoine.patrimoinePropertyService
    * @requires swif.framework.swifFrameworkService
    **/
    function patrimoinePropertyService($location, swif) {
        'ngInject';
        var service = {
            is_parcauto: false,
            getExistingCategories: getExistingCategories,
            getFilter: getFilter,
            getCategoryFilter: getCategoryFilter,

        };
        swif.settings.initialize().then(() => {
            service.STATES_OBJ = {
                'new' : swif.i18n.getString('New'),
                'good': swif.i18n.getString('Good'),
                'fair': swif.i18n.getString('Fair'),
                'bad': swif.i18n.getString('Bad'),
                'unsuitable': swif.i18n.getString('Unsuitable'),
                'dangerous': swif.i18n.getString('Dangerous')
            };
            service.STATES_CHOICES = [
                {id: 'new', name: service.STATES_OBJ.new},
                {id: 'good', name: service.STATES_OBJ.good},
                {id: 'fair', name: service.STATES_OBJ.fair},
                {id: 'bad', name: service.STATES_OBJ.bad},
                {id: 'unsuitable', name: service.STATES_OBJ.unsuitable},
                {id: 'dangerous', name: service.STATES_OBJ.dangerous}
            ];
        });
        return service;
        function getExistingCategories(propertyFilter) {
            propertyFilter.fields = ['id', 'name', 'category_id'];
            return swif.data.groupRead(
                'patrimoine_property',
                propertyFilter,
                ['category_id']
            );
        }
        function getFilter(current, addCategoriesFilter, categories) {
            var filter = {};
            var locFilter = $location.search().patrimoinePropertiesFilter;
            if (locFilter) {
                filter = angular.copy(JSON.parse(locFilter));
                // remove the filter from $location once we used it
                $location.search('patrimoinePropertiesFilter', null);
            } else if (current) {
                if (current._type === 'patrimoine_site' || current._type === 'site') {
                    swif.data.addExtraFilter(filter, 'extra', 'site_id.id', 'child_of', current.id);
                } else if (current._type === 'patrimoine_equipment') {
                    swif.data.addExtraFilter(filter, 'extra', 'equipment_id.id', '=', current.id);
                }
                if(addCategoriesFilter) {
                    // $scope.categories is result of readGroup()
                    // its format is: [category_id: [ID, NAME], category_id_count: 5]
                    var categ_ids = [];
                    _.forEach(categories, function (categ) {
                        categ_ids.push(categ.category_id[0]);
                    });
                    if(categ_ids.length > 0){
                        swif.data.addExtraFilter(filter, 'extra', 'category_id.id', 'in', categ_ids);
                    }
                }
            }
            return filter;
        }
        function getCategoryFilter() {
            var filter = {};
            if (service.is_parcauto) {
                swif.data.addExtraFilter(filter, 'is_parcauto', 'service_ids.is_parcauto', '=', true);
            }
            return filter;
        }
    }


})();
